/* istanbul ignore next */
export { default } from './wa-html-editor.jsx';